import { useContext, useEffect, useState } from 'react';
import { Center, Accordion, Text, Loader } from '@mantine/core';
import { IconChevronRight, IconFileDescription, IconTrash } from '@tabler/icons';
import { ContractContext } from '../../../Service/Context/ContractContextV2';
import { DocumentS } from '../../Documents/DocumentS';
import { ContractBlockButtons } from '../../../Organismns/Contract/AddBlockButtons';
import { DocumentDto } from '../../../Service/DocumentT';

const ContractDocumentBlock = () => {
  const { contract, savePatch } = useContext(ContractContext);
  const [loading, setLoading] = useState(false);
  const [bookingDocument, setBookingDocument] = useState<DocumentDto | null>(null);
  const { documentId } = contract ?? {};

  useEffect(() => {
    if (documentId) {
      setLoading(true);
      DocumentS.fetchById(documentId)
        .then(setBookingDocument)
        .finally(() => setLoading(false));
    }
  }, [documentId]);

  return (
    <>
      <Accordion
        variant="separated"
        chevronPosition="left"
        chevron={<IconChevronRight size="1rem" />}
        styles={{
          chevron: {
            '&[data-rotate]': {
              transform: 'rotate(90deg)',
            },
          },
        }}
        sx={{
          flexGrow: 1,
        }}
      >
        <Accordion.Item value="1">
          <Center>
            <Accordion.Control>
              {loading && (
                <>
                  <Loader size="xs" mr="xs" /> {'  '}Dokument{' '}
                </>
              )}
              {!loading && bookingDocument && (
                <>
                  <IconFileDescription size={20} style={{ marginRight: 10, marginTop: -3 }} />
                  {DocumentS.getDocumentDescription(bookingDocument)}
                </>
              )}
            </Accordion.Control>

            <IconTrash
              onClick={() => savePatch({ documentId: null })}
              size={20}
              style={{ cursor: 'pointer', marginRight: 10 }}
              className="hooverable-icon"
            />
          </Center>
          <Accordion.Panel>
            <Text italic color="dimmed">
              Positionen werden hier aus einem ausgewählten Dokument eingefügt.
            </Text>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
      <ContractBlockButtons isAbove={false} />
    </>
  );
};

export default ContractDocumentBlock;
